module.exports = __webpack_public_path__ + "img/AC.1e0e6221.png";